import React from 'react';
import { Row, Col, Card, CardBody, CardTitle, CardText, CardImg, Nav, NavLink } from 'reactstrap';
//import twitch and twitter icons
import { FaTwitch, FaTwitter } from 'react-icons/fa';
import { motion } from 'framer-motion'; // Import framer-motion
import ViewerTestimonials from './ViewerTestimonials';
import { useState } from 'react';
function Testimonials() {
  // Define animation variants for Framer Motion
  const cardVariants = {
    offscreen: {
      opacity: 0,
      y: 50,
    },
    onscreen: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        bounce: 0.3,
        duration: 0.8,
      },
    },
  };

  const imgHover = {
    rest: { scale: 1, rotate: 0 },
    hover: {
      scale: [null, 1, 1.1, 1.05],
      rotate: -3,
      transition: {
        duration: 0.5,
        type: 'spring',
        stiffness: 120,
      },
    },
  };

  const iconHover = {
    rest: { scale: 1, color: '#000' },
    hover: { scale: 1.2, color: '#1DA1F2', transition: { duration: 0.3 } }, // Color for Twitter icon
  };

  const tabVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };
  const [activeTab, setActiveTab] = useState('clients');

  const createCard = (name, img, twitter, twitch, text) => {
    return (
      <motion.div
        className="mb-3"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true, amount: 0.3 }}
        variants={cardVariants}>
        <Card>
          <CardBody>
            <CardTitle tag="h5">
              {name}
              <span style={{ float: 'right' }}>
                <motion.div whileHover="hover" initial="rest" variants={iconHover}>
                  <FaTwitch onClick={() => window.open(twitch)} style={{ cursor: 'pointer', marginRight: '10px' }} />
                </motion.div>
                <motion.div whileHover="hover" initial="rest" variants={iconHover}>
                  <FaTwitter onClick={() => window.open(twitter)} style={{ cursor: 'pointer' }} />
                </motion.div>
              </span>
            </CardTitle>
            <CardText>
              <Row>
                <Col>
                  <motion.div whileHover="hover" initial="rest" variants={imgHover}>
                    <CardImg src={img} alt={name} style={{ zIndex: -10 }} />
                  </motion.div>
                </Col>
                <Col style={{ textAlign: 'center', zIndex: 10 }}>{text}</Col>
              </Row>
            </CardText>
          </CardBody>
        </Card>
      </motion.div>
    );
  };

  return (
    <Row>
      <Col>
        <h2>Testimonials</h2>
        <Nav tabs justified className="mb-4">
          <NavLink onClick={() => setActiveTab('clients')} active={activeTab === 'clients'}>
            Clients
          </NavLink>
          <NavLink onClick={() => setActiveTab('viewers')} active={activeTab === 'viewers'}>
            Viewers
          </NavLink>
        </Nav>
        <motion.div initial="hidden" animate="visible" variants={tabVariants}>
          {activeTab === 'clients' ? (
            // Clients testimonials (existing code)
            <Row>
              <Col>
                {createCard(
                  'LuluLovely',
                  './lulu.png',
                  'https://twitter.com/lululovely',
                  'https://twitch.tv/lululovely',
                  <div>
                    <span>[placeholder]</span>
                    <br />
                    <ul style={{ float: 'left', textAlign: 'left' }}>
                      <strong>Services provided:</strong>
                      <li>Full YouTube management, including:</li>
                      <ul>
                        <li>YouTube video editing</li>
                        <li>Thumbnail creation</li>
                        <li>Search Engine Optimization</li>
                        <li>Channel growth strategy</li>
                      </ul>
                      <li>TikTok curation</li>
                      <li>Stream highlights</li>
                    </ul>
                    <ul style={{ float: 'left', textAlign: 'left' }}>
                      <strong>Statistics</strong>
                      <li>Over 3,000,000 total views</li>
                      <li>5,000 new subscribers monthly</li>
                      <li>300% increase in watch time</li>
                    </ul>
                    <span style={{ float: 'left', textAlign: 'left' }}>
                      Provided full brand transition services, separating gaming from the personal brand and launching a purely gaming
                      channel.
                    </span>
                  </div>
                )}
                {createCard(
                  'Allie',
                  './allie.png',
                  'https://twitter.com/allieaims',
                  'https://twitch.tv/allie',
                  <div>
                    <span>[placeholder]</span>
                    <br />
                    <ul style={{ float: 'left', textAlign: 'left' }}>
                      <strong>Services provided:</strong>
                      <li>YouTube channel creation and management</li>
                      <li>Stream highlights</li>
                      <li>Thumbnail creation</li>
                      <li>Funny moments/compilation videos</li>
                      <li>Full TikTok and YouTube Shorts management</li>
                    </ul>
                    <ul style={{ float: 'left', textAlign: 'left' }}>
                      <strong>Statistics</strong>
                      <li>555,437 views</li>
                      <li>Over 2,500 new subscribers, starting from 0</li>
                      <li>20% increase in watch time</li>
                    </ul>
                    <span style={{ float: 'left', textAlign: 'left' }}>
                      Managed YouTube, creating a presence that allowed viewer migration between platforms, enhancing overall brand
                      presence.
                    </span>
                  </div>
                )}
                {createCard(
                  'Mina',
                  './mina.png',
                  'https://twitter.com/Meenuhhh_',
                  'https://twitch.tv/mina',
                  <div>
                    <span>[placeholder]</span>
                    <br />
                    <ul style={{ float: 'left', textAlign: 'left' }}>
                      <strong>Services provided:</strong>
                      <li>TikTok creation</li>
                      <li>TikTok optimization</li>
                      <li>Keyword optimization for TikToks</li>
                      <li>Enhanced view retention</li>
                    </ul>
                  </div>
                )}
                {createCard(
                  'KeanuJTV',
                  './keanujtv.png',
                  'https://twitter.com/keanujtv',
                  'https://twitch.tv/keanujtv',
                  <div>
                    <span>[placeholder]</span>
                    <br />
                    <ul style={{ float: 'left', textAlign: 'left' }}>
                      <strong>Services provided:</strong>
                      <li>YouTube video editing</li>
                      <li>Success consulting</li>
                      <li>Consulted about:</li>
                      <ul>
                        <li>Channel growth</li>
                        <li>Video editing</li>
                        <li>User retention</li>
                      </ul>
                    </ul>
                    <span style={{ float: 'left', textAlign: 'left' }}>
                      Consulting with KeanuJTV resulted in increased viewer retention through improved video quality and editing, allowing
                      his channel to be accepted into the YouTube Partner Program.
                    </span>
                  </div>
                )}
              </Col>
            </Row>
          ) : (
            <ViewerTestimonials />
          )}
        </motion.div>
      </Col>
    </Row>
  );
}

export default Testimonials;
